import { images } from ".";

const events = [
    {
        id: 1,
        image: images.event1,
        title: "AI StartUp Networking Event",
        details: {
            date: "15 February, 2025",
            time: "9:00 AM",
            location: "Tech Hub",
            organizer: "AI Entrepreneurs Community",
            number: "+123-456-7890",
            email: "info@ainetworking.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at Tech Hub for an exclusive AI StartUp Networking Event. Connect with industry leaders, investors, and innovators shaping the future of AI-driven businesses.",
            "Gain valuable insights, participate in startup pitching sessions, and explore collaborative opportunities in the rapidly growing AI ecosystem."
        ],
        gallery: [
            images.event1Gallery1,
            images.event1Gallery2
        ],
        highlights: [
            "Networking Opportunities with AI & IT Entrepreneurs.",
            "Insightful Discussions on AI StartUp Challenges and Successes.",
            "Pitching Sessions for Startups Seeking Investment.",
            "Workshops on Building and Scaling AI-Based Startups.",
            "Expert Talks on AI Trends and Innovations."
        ],
        essentials: [
            "Business Cards for Networking",
            "Laptop/Tablet for Note-taking and Presentations",
            "Your Entrepreneurial Spirit and Ideas",
            "Passion for AI and StartUp Culture"
        ],
        guestIds: [2, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sTech%20Hub!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    {
        id: 2,
        image: images.event2,
        title: "IT Innovations & AI Conference",
        details: {
            date: "20 February, 2025",
            time: "10:00 AM",
            location: "In Center",
            organizer: "Tech Leaders Association",
            number: "+123-456-7890",
            email: "info@aiitconference.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at In Center for the IT Innovations & AI Conference, where industry pioneers, researchers, and tech enthusiasts converge to discuss the latest advancements in AI and IT solutions.",
            "Explore groundbreaking innovations, attend expert-led sessions, and network with professionals shaping the future of AI-driven technology."
        ],
        gallery: [
            images.event2Gallery1,
            images.event2Gallery2
        ],
        highlights: [
            "Panel Discussions on AI and Emerging IT Trends.",
            "Networking Opportunities with Industry Leaders.",
            "Live Demonstrations of AI-powered Innovations.",
            "Workshops on AI Applications in IT.",
            "Insights from Renowned AI Researchers and Experts."
        ],
        essentials: [
            "Business Cards for Networking",
            "Laptop/Tablet for Note-taking and Presentations",
            "Curiosity for AI and IT Innovations",
            "Professional Attire for Industry Networking"
        ],
        guestIds: [1, 4],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sIn%20Center!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    {
        id: 3,
        image: images.event3,
        title: "IT StartUp Pitch Competition",
        details: {
            date: "25 February, 2025",
            time: "2:00 PM",
            location: "Business Park",
            organizer: "Startup Innovators Hub",
            number: "+123-456-7890",
            email: "info@startupcompetition.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at Business Park for the IT StartUp Pitch Competition, where innovative minds showcase their groundbreaking ideas to investors, mentors, and industry experts.",
            "This is your chance to witness the next big tech disruption and connect with the brightest entrepreneurs shaping the future of IT startups."
        ],
        gallery: [
            images.event3Gallery1,
            images.event3Gallery2
        ],
        highlights: [
            "Live Startup Pitches to Top Investors.",
            "Networking with Entrepreneurs and VCs.",
            "Expert Feedback and Mentorship Sessions.",
            "Workshops on Startup Growth Strategies.",
            "Cash Prizes and Investment Opportunities."
        ],
        essentials: [
            "Business Cards for Networking",
            "Pitch Deck for Presenters",
            "Notebook or Tablet for Notes",
            "Passion for Startup Innovation"
        ],
        guestIds: [8, 3],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sBusiness%20Park!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    {
        id: 4,
        image: images.event4,
        title: "Digital Transformation Expo",
        details: {
            date: "05 March, 2025",
            time: "9:00 AM",
            location: "Expo Hall",
            organizer: "Tech Innovators Association",
            number: "+123-456-7890",
            email: "info@digitalexpo.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at Expo Hall for the Digital Transformation Expo, where leading tech companies, industry experts, and innovators showcase the latest advancements in AI, cloud computing, IoT, cybersecurity, and more.",
            "Experience cutting-edge technology, attend insightful keynote sessions, and explore how digital transformation is shaping the future of industries."
        ],
        gallery: [
            images.event4Gallery1,
            images.event4Gallery2
        ],
        highlights: [
            "Live Demonstrations of Emerging Technologies.",
            "Expert Panels on Digital Transformation Trends.",
            "Networking with Industry Leaders & Innovators.",
            "Workshops on Implementing AI & Automation.",
            "Exclusive Product Launches & Exhibits."
        ],
        essentials: [
            "Business Cards for Networking",
            "Notebook or Tablet for Notes",
            "Company Brochures for Exhibitors",
            "Enthusiasm for Tech Innovation"
        ],
        guestIds: [5, 6],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sExpo%20Hall!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    {
        id: 5,
        image: images.event5,
        title: "AI & IT StartUp Growth Summit",
        details: {
            date: "15 March, 2025",
            time: "10:00 AM",
            location: "Startup Hub",
            organizer: "Tech StartUp Network",
            number: "+123-456-7890",
            email: "info@startupgrowthsummit.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at Startup Hub for the AI & IT StartUp Growth Summit, where emerging tech entrepreneurs, investors, and industry leaders come together to discuss strategies for scaling AI and IT startups.",
            "Gain valuable insights from expert speakers, participate in networking sessions, and explore the latest trends shaping the future of AI-driven businesses."
        ],
        gallery: [
            images.event5Gallery1,
            images.event5Gallery2
        ],
        highlights: [
            "Keynote Sessions from AI & IT Industry Leaders.",
            "Networking Opportunities with Investors & Entrepreneurs.",
            "Workshops on Scaling AI-Based Startups.",
            "Panel Discussions on IT StartUp Challenges & Solutions.",
            "Pitching Sessions for Startups Seeking Investment."
        ],
        essentials: [
            "Business Cards for Networking",
            "Laptop/Tablet for Presentations",
            "Investor Pitch Decks & Business Proposals",
            "Passion for AI & IT Entrepreneurship"
        ],
        guestIds: [1, 8],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sStartup%20Hub!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    },
    {
        id: 6,
        image: images.event6,
        title: "Tech Entrepreneurs Forum",
        details: {
            date: "25 March, 2025",
            time: "3:00 PM",
            location: "Co Space",
            organizer: "Tech Innovators Network",
            number: "+123-456-7890",
            email: "info@techforum.com",
            fee: "Free Admission"
        },
        paragraphs: [
            "Join us at Co Space for the Tech Entrepreneurs Forum, a gathering of visionary startup founders, investors, and industry experts discussing innovation, challenges, and opportunities in the tech startup ecosystem.",
            "Engage in thought-provoking discussions, expand your network, and gain insights from successful entrepreneurs who have scaled their tech businesses globally."
        ],
        gallery: [
            images.event6Gallery1,
            images.event6Gallery2
        ],
        highlights: [
            "Panel Discussions with Successful Tech Founders.",
            "Networking Sessions with Investors & Mentors.",
            "Workshops on Product Development & Scaling.",
            "Insights into Emerging Tech Trends & Opportunities.",
            "Pitching Sessions for Startups Seeking Funding."
        ],
        essentials: [
            "Business Cards for Networking",
            "Laptop/Tablet for Note-taking & Presentations",
            "Investor Pitch Decks & Business Proposals",
            "Passion for Tech Innovation & Startups"
        ],
        guestIds: [7, 2],
        venueMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.745632503296!2d-74.00597268459362!3d40.71277617932966!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c25a3168729e03%3A0x6d0a0b2b15e364df!2sCo%20Space!5e0!3m2!1sen!2sus!4v1645287442276!5m2!1sen!2sus"
    }

];

export default events;